import React, { useState, useRef, useEffect } from 'react';
import cn from 'classnames';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import FolderIcon from '~/Components/Global/Assets/Svgs/FolderIcon';
import { updateFolder } from '~/Redux/Modules/Folders';
import { updateList } from '~/Redux/Modules/UserLists';
import Trash from '~/Components/Global/Assets/Svgs/Trash';
import Edit from '~/Components/Global/Assets/Svgs/Edit';

const Folder = props => {
  const {
    lists,
    folder,
    deleteFolder,
    dispatchUpdateFolder,
    isActive,
    dispatchUpdateList,
    handleFolderClick,
    showSubMenu,
  } = props;
  const [isEditing, setIsEditing] = useState(false);
  const inputRef = useRef(null);
  const [editFolderTitle, setEditFolderTitle] = useState('');

  const handleDeleteFolder = id => {
    const listsInFolder = lists.filter(list => list.list_group_id === id);
    if (window.confirm(`Are you sure you want to delete ${folder.title}?`)) {
      deleteFolder({ id: id });
      if (listsInFolder) {
        listsInFolder.map(list => {
          return dispatchUpdateList({ ...list, list_group_id: null });
        });
      }
    }
  };

  const finishEditFolderName = () => {
    if (editFolderTitle) dispatchUpdateFolder({ ...folder, title: editFolderTitle });
    setIsEditing(false);
  };

  const handleEditFolderName = event => {
    setEditFolderTitle(event.target.value);
  };

  const handleKeyDown = event => {
    if (isEditing && event.keyCode === 13) {
      event.preventDefault();
      finishEditFolderName();
    }
  };

  useEffect(() => {
    if (isEditing) {
      inputRef.current.focus();
    }
  }, [isEditing]);

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isEditing]);

  const handleClickOutside = event => {
    event.stopPropagation();
    event.preventDefault();
    if (!event || !event.target) {
      return;
    }
    const triggeringElement = event.target;
    const classNameToCheck = 'do-not-close-dropdown';
    if (
      inputRef.current &&
      !inputRef.current.contains(triggeringElement) &&
      !triggeringElement.classList.contains(classNameToCheck)
    ) {
      setIsEditing(false);
    }
  };

  const onDeleteFolder = e => {
    e.preventDefault();
    e.stopPropagation();
    handleDeleteFolder(folder.id);
  };

  const onEditFolder = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsEditing(true);
    setEditFolderTitle(folder.title);
  };

  return (
    <div
      role="button"
      tabIndex="0"
      className={cn(
        'folder-container',
        'do-not-close-dropdown',
        showSubMenu && isActive ? 'folder-open' : null
      )}
    >
      <div
        onClick={e => handleFolderClick(e, !isActive, folder.id)}
        className="dropdown-folder"
        id={folder.id}
        key={folder.id}
      >
        <FolderIcon />
        {isEditing ? (
          <input
            name="editFolder"
            className="do-not-close-dropdown edit-folder-title"
            value={editFolderTitle}
            onKeyDown={handleKeyDown}
            ref={inputRef}
            onChange={handleEditFolderName}
          />
        ) : (
          <span className={cn('folder-title')}>{folder.title}</span>
        )}
        <div className={`folder-buttons ${isEditing ? 'hidden' : ''}`}>
          <div onClick={e => onEditFolder(e)} className="do-not-close-dropdown">
            <Edit
              role="button"
              tabIndex="0"
              title="Edit"
              className="do-not-close-dropdown folder-edit-icon"
            />
          </div>
          <div onClick={e => onDeleteFolder(e)}>
            <Trash role="button" tabIndex="0" className="folder-trash-icon" />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
  return {
    dispatchUpdateFolder: data => dispatch(updateFolder(data)),
    dispatchUpdateList: data => dispatch(updateList(data)),
  };
};

Folder.propTypes = {
  lists: propTypes.array,
  deleteFolder: propTypes.func,
  dispatchUpdateFolder: propTypes.func,
  isActive: propTypes.bool,
  folder: propTypes.object,
  dispatchUpdateList: propTypes.func,
  handleFolderClick: propTypes.func,
  showSubMenu: propTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(Folder);
